import { render, staticRenderFns } from "./AddResellerServicePage.vue?vue&type=template&id=347564fa"
import script from "./AddResellerServicePage.vue?vue&type=script&lang=js"
export * from "./AddResellerServicePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports